/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type bookmarkunsetBySpaceIdMutationVariables = {|
  userRef: string,
  spaceId: string,
|};
export type bookmarkunsetBySpaceIdMutationResponse = {|
  +result: ?{|
    +code: number,
    +success: boolean,
    +message: string,
  |}
|};
export type bookmarkunsetBySpaceIdMutation = {|
  variables: bookmarkunsetBySpaceIdMutationVariables,
  response: bookmarkunsetBySpaceIdMutationResponse,
|};
*/


/*
mutation bookmarkunsetBySpaceIdMutation(
  $userRef: String!
  $spaceId: String!
) {
  result: unsetSpaceBookmark(userRef: $userRef, spaceId: $spaceId) {
    code
    success
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userRef"
},
v2 = [
  {
    "alias": "result",
    "args": [
      {
        "kind": "Variable",
        "name": "spaceId",
        "variableName": "spaceId"
      },
      {
        "kind": "Variable",
        "name": "userRef",
        "variableName": "userRef"
      }
    ],
    "concreteType": "SpaceBookmarkPayload",
    "kind": "LinkedField",
    "name": "unsetSpaceBookmark",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "bookmarkunsetBySpaceIdMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "bookmarkunsetBySpaceIdMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f725a88083f601fc3b877ebd45c8d220",
    "id": null,
    "metadata": {},
    "name": "bookmarkunsetBySpaceIdMutation",
    "operationKind": "mutation",
    "text": "mutation bookmarkunsetBySpaceIdMutation(\n  $userRef: String!\n  $spaceId: String!\n) {\n  result: unsetSpaceBookmark(userRef: $userRef, spaceId: $spaceId) {\n    code\n    success\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1abeeddf79414e80d7f7208c6b426180';

module.exports = node;
